<template>
  <b-col md="12" sm="12" v-if="propostas.data !== undefined">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <h1 tabindex="0">Cadernos de Propostas</h1>
      </b-card-body>
    </b-card>
    <b-card no-body class="mx-4">
      <b-card-body class="p-8">
        <b-row>

          <b-col class="col-md-3 col-sm-12" v-for="proposta in propostas.data" :key="proposta.id">
            <b-card  @click="abrirProposta(proposta.id)" :class="'card-button ' + proposta.cor_bloco" :style="'height: 340px; font-size: 20px; vertical-align: middle; cursor: pointer; background:' +  proposta.cor_bloco ">
              <strong>{{proposta.titulo}}</strong>       
            </b-card>
          </b-col>          
        </b-row>
      </b-card-body>
    </b-card>
  </b-col>
  <b-col md="12" sm="12" v-else>
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
       
      </b-card-body>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  data () {
    return {
      loading: false,
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      form: {
        id: '',
        titulo: '',
        descricao: '',
        eixo: ''
      },
      propostas: [],      
      regimentoAtivo: true,
      resourceSugestao: '',
      resourceComentario: '',
      modalSugestaoEdicao: false,
      modalSugestaoExclusao: false,
      modalComentario: false,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
  },
  mounted () {
     this.carregarCadernos()
  },
  methods: {
    abrirProposta (id) {
      this.navigate('/proposta/' + id)
    },
    carregarCadernos(){
      Vue.http.get('api/proposta?conferencia_id=' + this.conferencia_id+ '&situacao=E&visivel_encerrado=true').then(response => {
          if (response.body.success) {
            this.propostas = response.body.data           
          }
        })
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>

<style scoped>
.verde {
  background-color: #36b536;
}
.azul {
  background-color: #3f5ea1;
}
.amarelo {
   background-color: #ffe605;
}
.vermelho {
   background-color: #ff0505;
}
.roxo {
   background-color: #d505ff;
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/caderno/PropostaEntrada.vue